<div class="container-fluid for_school_user">
  <div class="row align-items-center login-font flex-res r-form">
    <div class="card">
      <div class="row align-items-center">
        <div class="col-md-12 col-lg-6 p-0 rounded-0 border-0 login_background_image">
          <div class="d-flex position-relative">
            <img alt="" class="img-fluid w-100" src="../../../../assets/images/favicon/Group 1000001671.png" />
            <div class="position-absolute w-100 card-text-white">
              <div class="card-body login-content">
                <p class="join_hub">
                  <span class="hub">The ultimate hub</span>
                  for jobs and bookings in education
                </p>
                <div class="d-flex mt-20">
                  <p class="txt-regular fs-16 class-txt">New to ClassCover?</p>
                  <a class="text-regular-medium fs-16 u_l class-txt ml-5" href="https://www.classcover.com.au/lets-make-sure-you-are-in-the-right-place/">
                    <b>Get started</b>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="">
            <div class="register-form">
              <div class="px-0 pt-5 mb-4">
                <p>
                  <img alt="" class="r_image" src="assets/images/favicon/CClogoFINAL-02 1.png" />
                </p>
                <p class="mt-50 txt-regular fs-18">Login to ClassCover</p>
                <p class="text-regular mt-20 mb-20 txt-sso-login">Login with your Queensland Department of Education credentials</p>
                <button type="submit" (click)="loginWithSSO()" aria-label="Login" class="btn w-100 cc_p_btn fs_13">Login</button>
                <!-- login-error.component.html -->
                 @if(showEror){                  
                  <div class="error-container">
                    <div class="error-icon">
                      <i class="bi bi-exclamation-circle-fill"></i>
                    </div>
                    <div class="error-message">
                      <h4>Unable to log you in</h4>
                      <p>Please verify your ClassCover access with the Department of Education Queensland.</p>
                      <p>
                        Please reach out to
                        <a href="mailto:support&#64;classcover.com.au">support&#64;classcover.com.au</a>
                      </p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
